document.addEventListener('DOMContentLoaded', function () {
    // Open the Terms & Conditions modal when the "Terms of Use" link is clicked.
    const termsLinkContainer = document.getElementById('cop-terms-of-use-link');
    if (!termsLinkContainer) {
        return;
    }

    const overlay = document.getElementById('terms-overlay');
    const termsContainer = document.querySelector('.terms__container');
    if (!overlay || !termsContainer) {
        return;
    }

    const links = termsLinkContainer.querySelectorAll('a');
    links.forEach(function (link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            overlay.style.display = 'block';
            termsContainer.style.display = 'block';
        });
    });

    // Close the modal (instead of redirecting) when the primary "Close" button is clicked.
    const closeActionButton = termsContainer.querySelector(
        '.cmp-button--primary-positive .terms__action-button'
    );
    if (closeActionButton) {
        closeActionButton.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            overlay.style.display = 'none';
            termsContainer.style.display = 'none';
        });
    }
});
